<template>
  <div class="conteudo">
    <div
      v-for="(item, idx) in itens"
      :key="idx"
      class="item-lista"
    >
      <div class="titulo">{{ item.titulo }}</div>

      <div class="valor">
        {{ item.converter_embalagem ? formatarValor(converteEmbalagemValor(dados[item.valor])) : formatarValor(dados[item.valor]) }}
        <template v-if="item.append">{{ item.append }}</template>
      </div>
    </div>
  </div>
</template>

<script>
import {formatarValor} from "@/helpers";
import {mapGetters} from "vuex";

export default {
  name: "DetalhesProduto",
  props: {
    dados: Object
  },
  data: () => ({
    itens: [
      { titulo: 'Estoque', valor: 'estoque', converter_embalagem: true },
      { titulo: 'Cobertura Estoque', valor: 'cobertura_estoque', append: 'dias', converter_embalagem: false },
      { titulo: 'Estoque Segurança', valor: 'estoque_seguranca', converter_embalagem: true },
      { titulo: 'Cobertura Estoque Segurança', valor: 'cobertura_estoque_seguranca', append: 'dias', converter_embalagem: false },
      { titulo: 'Ponto de Pedido', valor: 'ponto_pedido', converter_embalagem: true },
      { titulo: 'Cobertura Ponto de Pedido', valor: 'cobertura_ponto_pedido', append: 'dias', converter_embalagem: false },
      { titulo: 'Estoque Máximo', valor: 'estoque_maximo', converter_embalagem: true },
      { titulo: 'Cobertura Estoque Máximo', valor: 'cobertura_estoque_maximo', append: 'dias', converter_embalagem: false },
      { titulo: 'Proj. de Vendas', valor: 'consumo_medio_mensal', converter_embalagem: true },
      { titulo: 'Tempo Ressuprimento', valor: 'tempo_medio_ressuprimento', append: 'dias', converter_embalagem: false },
      { titulo: 'Lote Mínimo', valor: 'lote_minimo', converter_embalagem: true },
    ],
  }),
  computed: {
    ...mapGetters({
      embalagemMasterAtivada: "EmbalagemTelaDeCompras/getEmbalagemMaster",
    }),
  },
  methods: {
    formatarValor,
    converteEmbalagemValor(valor) {
      const multiplo_compra = this.dados.multiplo_compra ? this.dados.multiplo_compra : 1;

      if (this.dados.tipo_fator_conversao === 'D') {
        return this.embalagemMasterAtivada ? (valor / multiplo_compra) : valor;
      }

      return this.embalagemMasterAtivada ? (valor * multiplo_compra) : valor;
    },
  }
}
</script>

<style scoped>
.conteudo {
  border: 1px solid #e1dfdf;
  border-bottom: 0;
  background: white;
}
.item-lista {
  display: flex;
  border-bottom: 1px solid #e1dfdf;
  font-size: 12px;
  color: #595959;
}
.item-lista .titulo {
  padding: 2px 5px;
  font-weight: 600;
  background: #e3efff;
  width: 180px;
}
.item-lista .valor {
  padding-left: 5px;
  text-align: center;
  margin: auto;
}
</style>
